export const enum ManagerType {
  Root = 1,
  ProjectAdmin = 2,
  OrganizationAdmin = 3,
  OrganizationReviewer = 4,
  Unit = 5,
  Single = 6,
  Normal = 7,
}

export const LAYOUT = () => import("/@/layout/PageLayout.vue");
